import { FC } from "react";

import { Navigate, Route, Routes } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { DEFAULT_LOCALE } from "@granular/fabric3-definitions";
import translations from "../../../i18n";
import { AutoIdFlow } from "./flows/AutoIdFlow";
import { SelfIdFlow } from "./flows/SelfIdFlow";
import { AutoLoginAfterInvite } from "./flows/AutoLoginAfterInvite";
import { InviteRedeem } from "./flows/InviteRedeem";
import styles from "./Login.module.css";
import { useSSOLocale } from "./customHooks";
import { useMount } from "../../hooks/mount";
import { ErrorBoundary } from "react-error-boundary";
// The default Fallback export uses `withIntlProvider`, which we don't want here.
import { Fallback as FallbackNoIntl } from "../ErrorFallback";
import { setSSOImplementation } from "../../services/auth/auth";
import { LoginFeatureFlagsProvider } from "./LoginFeatureFlags";

const Login: FC = () => {
  const locale = useSSOLocale();

  // If we're on this page, we should be using SPA SSO.
  useMount(() => {
    setSSOImplementation("spaSSO");
  });

  return (
    <IntlProvider
      locale={locale}
      messages={translations[locale]}
      defaultLocale={DEFAULT_LOCALE}
    >
      <ErrorBoundary FallbackComponent={FallbackNoIntl}>
        <LoginFeatureFlagsProvider>
          <div className={styles.loginContainer}>
            <Routes>
              {/* Routes subject to change */}
              <Route path="*" element={<Navigate to="auto-identify" />} />
              <Route path="auto-identify" element={<AutoIdFlow />} />
              <Route path="identify" element={<SelfIdFlow />} />
              <Route
                path="auto-login-invite"
                element={<AutoLoginAfterInvite />}
              />
              <Route path="invite/redeem" element={<InviteRedeem />} />
            </Routes>
          </div>
        </LoginFeatureFlagsProvider>
      </ErrorBoundary>
    </IntlProvider>
  );
};

export default Login;
